import { render, staticRenderFns } from "./listAffiliates.vue?vue&type=template&id=a0a07b00"
import script from "./listAffiliates.vue?vue&type=script&lang=js"
export * from "./listAffiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports